/**
 * Détecte automatiquement le chemin de base (ex. /tarjemliPlateforme/frontend/build)
 * quand l'app est servie depuis un sous-dossier Apache/WAMP.
 */
const basename = document.baseURI.substring(
  document.baseURI.indexOf(window.location.origin) + window.location.origin.length,
  document.baseURI.lastIndexOf('/'),
);

export default basename;
